module.exports = __webpack_public_path__ + "media/images/flags/32/Greece-c9099365f545933aa8d641f6df2835c2.png";